import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ColDef, ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { ToastrService } from "ngx-toastr";
import { ReportService } from "src/app/services/report/report.service";
import { VendorService } from "src/app/services/vendor.service";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ExcelService } from "src/app/services/excel.service";
import { GeoService } from "src/app/services/geo.service";
import { CustomerService } from "src/app/services/customer.service";
import { UserManagementService } from "src/app/services/user-management.service";
import { AppCoreService } from "src/app/services/app-core.service";
import { NetworkService } from "src/app/services/network.service";
import { ProductService } from "src/app/services/products.service";
import { Utilities } from "../../models/utilities";
import { CompanyService } from "src/app/services/company.service";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Title } from "@angular/platform-browser";

interface ExtendedColDef extends ColDef {
    visible?: boolean;
}

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss']
})

export class ReportComponent implements OnInit, AfterViewInit {

    @ViewChild('columnSelectorModal') columnSelectorModal!: TemplateRef<any>;
    allColumnsSelected = true;
    selectedColumns: string[] = [];
    allColumns: any[] = [];
    modalRef: NgbModalRef | undefined;
    
    reportForm: FormGroup;
    currentDate: any;
    isFormSubmitted = false;
    categoryOptions: any[] = [];
    typeOptions: any[] = [];
    reportOptions: any[] = [];
    vendorList: any[];
    title: any = "Report";
    originCityList: any[] = [];
    destinationCityList: any[] = [];
    countryCode: any;
    countryList: any[] = [];
    destinationStateList: any[] = [];
    originStateList: any[] = [];
    customerList: any[] = [];
    defaultCustomer: any;
    serviceCenterList: any[] = [];
    productList: any[] = [];
    userType: any;
    userList: any[] = [];
    businessTypeList = ['B2B', 'B2C'];
    isDisabled: boolean = true;
    productTypeList = ['Domestic', 'International', 'Import'];
    averageList = ['3 Months', '6 Months', 'Year'];
    reportOnList = ['Amount', 'Weight'];
    customerTypeList = ['Customer', 'Co-Courier', 'Franchisee'];
    selectedSCId: number;
    showFiledAnalysisReports = false;
    showProjectionReports = false;
    showMisReports = false;
    showDeliveryReports = false;
    showDailyReports = false;
    showZeroReports = false;
    showVOIDReports = false;
    showInvoiceReports = false;
    companyList: any[] = [];
    paymentTypeList = ['Credit', 'Cash', 'COD'];

    reportTypeList = [
        { "value": "D", "type": "Date Wise" },
        { "value": "N12", "type": "No Sales Last 12 month" },
        { "value": "N6", "type": "No Sales Last 6 month" },
        { "value": "N3", "type": "No Sales Last 3 month" },
        { "value": "Y12", "type": "Sales Last 12 month" },
        { "value": "Y6", "type": "Sales Last 6 month" },
        { "value": "Y3", "type": "Sales Last 3 month" },
        { "value": "MW", "type": "Month Wise" },
        { "value": "QW", "type": "Quarter Wise" },
        { "value": "YEW", "type": "Year Wise" },
        { "value": "SPF", "type": "Sales Performance" }
    ];

    misReportType = [{ name: 'All', value: '' }, { name: 'Delivered', value: 'SHIPMENT_DELIVERED' }, { name: 'Un Delivered', value: 'SHIPMENT_UNDELIVERED' },
    { name: 'Pending', value: 'Pending' }, { name: 'RTO', value: 'SHIPMENT_RETURNED' }]
    deliveryReportStatus = [{ name: 'All', value: '' }, { name: 'Delivered', value: 'SHIPMENT_DELIVERED' }, { name: 'Un Delivered', value: 'SHIPMENT_UNDELIVERED' }]

    lockType = [{ name: 'All', value: '' }, { name: 'Lock', value: true }, { name: 'Un Lock', value: 'false' }]

    showButton= false;
    categoryName : string;

    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;
    defaultColDef = {
        sortable: true,
        resizable: false,
        filter: true
    };

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 15,
        domLayout: 'autoHeight',
        colResizeDefault: 'shift',
    }

    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    }

    ngbModalOptions: NgbModalOptions = {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        centered: true
    };

    originalColumnDefs: ExtendedColDef[];
    columnDefs: ExtendedColDef[] = [];

    rowData = [];
    useEnterKey: any;

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    constructor(
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private reportService: ReportService,
        private ngxLoadService: NgxUiLoaderService,
        private excelService: ExcelService,
        private geoService: GeoService,
        private vendorService: VendorService,
        private customerService: CustomerService,
        private userService: UserManagementService,
        private appCoreService: AppCoreService,
        private userManagmentService: UserManagementService,
        private networkService: NetworkService,
        private productService: ProductService,
        private utilities: Utilities,
        private companyService: CompanyService,
        private modalService: NgbModal,
        private titleService : Title

    ) {
        this.titleService.setTitle('Standard Report');
     }

    ngOnInit(): void {
        this.checkPermission();

        this.currentDate = this.formateDate().dateString;
        this.reportForm = this.formBuilder.group({
            ddlCategory: [null, Validators.compose([Validators.required])],
            ddlType: [null, Validators.compose([Validators.required])],
            ddlReports: [null, Validators.compose([Validators.required])],
            txtFromDate: [this.currentDate],
            txtToDate: [this.currentDate],
            ddlProductType: [null],
            ddlProduct: [null],
            ddlServiceCenter: [null],
            ddlSalesExecutive: [null],
            ddlBusinessType: [null],
            ddlCustomerType: [null],
            ddlReportType: [null],
            ddlOriginCountry: [],
            ddlOriginState: [],
            ddlOriginCity: [],
            ddlDestinationCountry: [null],
            ddlDestinationState: [],
            ddlVendorService: [null],
            ddlDestinationCity: [],
            ddlVendor: [null],
            ddlCustomer: [null],
            ddlReportOn: [null],
            ddlAverage: [null],
            ddlMisReportType: [null],
            ddForwardinglVendor: [null],
            ddlDeliveryReportStatus: [null],
            ddlCompanies: [null],
            ddlPaymentType: [null],
            txtAwbNumber: [null],
            ddlLockType: [null],
        });
        this.getAllCategory();
        this.bindCountries();
        this.bindVendor();
        this.getServiceCenters();
        this.bindProducts();
        this.bindCompanies();
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.reportForm) : null;
    }

    checkPermission(): any {
        this.appCoreService.SelectedServiceCenter().subscribe((val) => {
            this.selectedSCId = val;
            this.bindUsers(val);
            this.bindCustomers(val);
        });
        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        const permission = userData.config.filter(x => x.categoryname === 'Reports');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.getPermittedServiceCenters(userData.userId);
        }
        this.defaultCustomer = userData.metaInfo?.customerid;
        this.userType = userData.accessType;
    }

    getPermittedServiceCenters(id: any) {
        this.userService.GetUserById(id).subscribe(res => {
            if (res?.success) {
            }
        })
    }

    getAllCategory() {
        // this.reportService.getAllCategory().subscribe((res) => {
        //     if (res && res.success) {
        //         const userData = this.appCoreService.GetUserData();
        //         const permission = userData.config.filter(x => x.categoryname === 'CustomReports');
        //         let filteredData = res.data;
     
        //         if (!permission.length) {
        //             filteredData = filteredData.filter(x => x.name !== 'Custom Reports');
        //         }
    
        //         this.categoryOptions = this.userType === 'Customer' 
        //             ? filteredData.filter(x => x.name === 'Customer Login Reports')
        //             : filteredData.filter(x => x.name !== 'Customer Login Reports');
    
        //         // console.log("this.categoryOptions", this.categoryOptions);
        //     }
        // });
    }


    bindType() {
        this.reportForm.get('ddlType').reset();
        this.reportForm.get('ddlReports').reset();
        this.showFiledAnalysisReports = false;
        this.showProjectionReports = false;
        this.showMisReports = false;
        this.showDeliveryReports = false;
        this.showDailyReports = false;
        this.showZeroReports = false;
        this.showVOIDReports = false;
        this.showInvoiceReports = false; 

        const id = this.reportForm.get('ddlCategory').value;
        if (id) {
            // this.reportService.getTypeByCategoryId(id).subscribe((res) => {
            //     if (res && res.success) {
            //         this.typeOptions = res.data;

            //         if (res.data.length == 1) {
            //             this.reportForm.get('ddlType').setValue(res.data[0].id);
            //             this.bindReport();
            //         }
            //     }
            // })
        }
        else {
            this.reportForm.get('ddlType').reset();
            this.showFiledAnalysisReports = false;
            this.showProjectionReports = false;
            this.showDeliveryReports = false;
            this.showDailyReports = false;
            this.showZeroReports = false;
            this.showVOIDReports = false;
            this.showInvoiceReports = false;
            this.typeOptions = [];
        }
    }

    bindReport() {
        const id = this.reportForm.get('ddlType').value;
        if (id) {
            // this.reportService.getReportByReportTypeId(id).subscribe((res) => {
            //     if (res && res.success) {
            //         this.reportOptions = res.data?.reports?.length ? res.data.reports : res.data?.customReport || [];
                
            //         if (this.reportOptions.length === 1) {
            //             const selectedReport = this.reportOptions[0];
            //             this.reportForm.get('ddlReports')?.setValue(selectedReport.id);
            //             this.onReportChange(selectedReport);
            //         }
            //     }
            // })
        }
        else {
            this.reportForm.get('ddlReports').reset();
            this.reportOptions = [];
        }
    }

    onReportChange(data?: any): Promise<string[]> {
        const reportId = this.reportForm.get('ddlReports').value;
        // console.log("reportId", reportId);

        let categoryValue = this.reportForm.get('ddlCategory')?.value;
        // console.log("categoryValue", categoryValue)
        this.categoryName = this.categoryOptions.find(x => x.id === categoryValue)?.name; 

        const reqObj = {
            id: reportId,
            categoryname: this.categoryName
        }

        this.title = data ? data.title : 'Report';
        const report: string = this.reportOptions.filter(x => x.id == this.reportForm.get('ddlReports').value)[0].name;
        report.toLocaleLowerCase() == 'analysis' ? this.showFiledAnalysisReports = true : this.showFiledAnalysisReports = false;
        report.toLocaleLowerCase() == 'projection' ? this.showProjectionReports = true : this.showProjectionReports = false;
        report.toLocaleLowerCase() == 'mis' ? this.showMisReports = true : this.showMisReports = false;
        report.toLocaleLowerCase() == 'delivery' ? this.showDeliveryReports = true : this.showDeliveryReports = false;
        report.toLocaleLowerCase() == 'daily' ? this.showDailyReports = true : this.showDailyReports = false;
        report.toLocaleLowerCase() == 'zero' ? this.showZeroReports = true : this.showZeroReports = false;
        report.toLocaleLowerCase() == 'void' ? this.showVOIDReports = true : this.showVOIDReports = false;
        report.toLocaleLowerCase() == 'invoice' ? this.showInvoiceReports = true : this.showInvoiceReports = false;

        return new Promise((resolve, reject) => {
            try {
                // this.ngxLoadService.start();
                // this.reportService.getSelectedColumns(reqObj).subscribe(res => {
                //     this.ngxLoadService.stop();
                //     if (res && res.success) {
                //         // console.log("res.data-reportchange", res.data[0]);
                //         this.selectedColumns = res.data[0]?.selectedcolumns ? res.data[0].selectedcolumns : [];
                //         this.allColumns = res.data[0]?.allcolumns ? res.data[0].allcolumns : [];
                //         resolve(this.selectedColumns);
                //     } else {
                //         this.selectedColumns = [];
                //         resolve(this.selectedColumns);
                //     }
                // }, error => {
                //     this.ngxLoadService.stop();
                //     console.error(error);
                //     this.selectedColumns = [];
                //     reject(error);
                // });
            } catch (e) {
                this.ngxLoadService.stop();
                console.error(e);
                this.selectedColumns = [];
                reject(e);
            }
        });
    }

    filterData() {
        this.isFormSubmitted = true;
        const fromdate = new Date(this.reportForm.get('txtFromDate').value);
        const todate = new Date(this.reportForm.get('txtToDate').value);
        const maxToDate = new Date(fromdate);
        maxToDate.setMonth(maxToDate.getMonth() + 3);

        if (fromdate > todate) {
            this.showWarningNotification('To Date should be greater than From Date');
            return;
        }

        if (todate > maxToDate) {
            this.openWarningMessageDialog('ToDate should not exceed 6 months from FromDate.');
            return;
        }

        if (this.reportForm.valid) {
            const categorytype = this.categoryOptions.filter(x => x.id == this.reportForm.get('ddlCategory').value)
            // console.log("categorytpe--", categorytype[0].name);
           
            let typeValue = this.reportForm.get('ddlType')?.value;
            let type = this.typeOptions.find(x => x.id === typeValue)?.name;  // Removed `.id` if typeValue is an ID


            this.rowData = [];
            const report: any = this.reportOptions.filter(x => x.id == this.reportForm.get('ddlReports').value);
            const reqObj = {
                category: this.reportForm.get('ddlCategory').value,
                type: this.reportForm.get('ddlType').value,
                typename: type,
                categoryname: this.categoryName,
                //reportType: this.reportForm.get('ddlReports').value,
                reportType: this.categoryName == 'Custom Reports' ? 'Custom Report' : report[0].name,
                fromdate: this.reportForm.get('txtFromDate').value,
                todate: this.reportForm.get('txtToDate').value,
                customer: this.reportForm.get('ddlCustomer').value,
                vendor: this.reportForm.get('ddlVendor').value,
                productType: this.reportForm.get('ddlProductType').value,
                originCountry: this.reportForm.get('ddlOriginCountry').value,
                originState: this.reportForm.get('ddlOriginState').value,
                originCity: this.reportForm.get('ddlOriginCity').value,
                destinationCountry: this.reportForm.get('ddlDestinationCountry').value,
                destinationState: this.reportForm.get('ddlDestinationState').value,
                destinationCity: this.reportForm.get('ddlDestinationCity').value,
                product: this.reportForm.get('ddlProduct').value,
                servicecenter: this.reportForm.get('ddlServiceCenter').value,
                salesexecutive: this.reportForm.get('ddlSalesExecutive').value,
                customertype: this.reportForm.get('ddlCustomerType').value,
                bussinesstype: this.reportForm.get('ddlBusinessType').value,
                misreporttype: this.reportForm.get('ddlMisReportType').value,
                forwardingvendor: this.reportForm.get('ddForwardinglVendor').value,
                deliveryStatus: this.reportForm.get('ddlDeliveryReportStatus').value,
                company: this.reportForm.get('ddlCompanies').value,
                paymentType: this.reportForm.get('ddlPaymentType').value,
                awbnumber: this.reportForm.get('txtAwbNumber').value,
                lockType: this.reportForm.get('ddlLockType').value,
            } 

            this.ngxLoadService.start(); 

            this.reportService.GetAll(reqObj).subscribe((res) => {
                if (res && res.success) {
                    if (res.data?.length) { 
                        
                        this.categoryName === 'Custom Reports' ? this.showButton = false : this.showButton = true;

                        this.ngxLoadService.stop();
                        this.rowData = [...res.data];                        
                        if (this.rowData.length > 0) {
                            if (this.selectedColumns && this.selectedColumns.length > 0) {
                                this.columnDefs = Object.keys(this.rowData[0]).map(key => ({
                                    headerName: key
                                        .split('_')
                                        .map((word, index) =>
                                            index === 0
                                                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                        .join('_'),
                                    field: key,
                                    hide: false
                                }));
                                const normalizedSelectedColumns = Object.keys(this.rowData[0]).map(key => key.toLowerCase());
                                this.rowData = this.rowData.map(row => {
                                    let filteredRow = {};
                                    normalizedSelectedColumns.forEach(column => {
                                        if (row.hasOwnProperty(column)) {
                                            filteredRow[column] = row[column];
                                        } else {
                                            // console.log("Column not found in row");
                                        }
                                    });
                                    return filteredRow;
                                });
                            } else {
                                this.columnDefs = Object.keys(this.rowData[0]).map(key => ({
                                    headerName: key
                                        .split('_')
                                        .map((word, index) =>
                                            index === 0
                                                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                        .join('_'),
                                    field: key,
                                    hide: false
                                }));

                                // this.columnDefs = Object.keys(this.rowData[0]).map(key => ({
                                //     headerName: key.charAt(0).toUpperCase() + key.slice(1),
                                //     field: key,
                                //     hide: false
                                // }));
                                this.allColumns = this.columnDefs.map(columns => columns.field);
                            }
                            this.updateColumnVisibilityState();
                            this.gridApi.setColumnDefs(this.columnDefs);
                            this.gridApi.setRowData(this.rowData);
                            this.gridApi.sizeColumnsToFit();
                        }
                    } else {
                        this.ngxLoadService.stop();
                        this.rowData = [];
                        this.columnDefs = [];
                        this.gridApi.setRowData([]);
                        this.gridApi.setColumnDefs([]);
                        this.showInfoNotification('No Data found!');
                    }
                } else if (res && !res.success) {
                    this.ngxLoadService.stop();
                    this.showInfoNotification(res.message);
                }
            });
            this.ngxLoadService.stop();
        }
    }

    exportExcel() {
        if (this.rowData.length) {
            let reportName = this.typeOptions.filter(x => x.id == this.reportForm.get('ddlType').value)[0].name;
            this.excelService.exportAsExcelFile(this.formatData(this.rowData), reportName);
        }
        else {
            this.showInfoNotification("No data to export");
        }
    }

    formatData(data: any) {
        let reports: any[] = [];
        reports = data;
        // for (var i =0; i< data; i++) {
        //     reports.push(data[i]);
        //     // reports.push({
        //     //     'Awb Number': report.awbnumber,
        //     //     'Weight': report.actualweight,
        //     //     'Booking Date': report.bookingdate,
        //     //     'Shipper': report.shippername,
        //     //     'Consignee': report.consigneename,
        //     //     'Company': report.companyname,
        //     //     'Customer': report.customername,
        //     //     'Vendor': report.vendorname,
        //     //     'Service': report.servicename,
        //     //     'Product': report.productname,
        //     //     'Origin Country': report.origincountry,
        //     //     'Origin State': report.originstate,
        //     //     'Origin City': report.origincity,
        //     //     'Destination Country': report.destinationcountry,
        //     //     'Destination State': report.destinationstate,
        //     //     'Destination City': report.destinationcity,
        //     //     'Transaction Status': report.transactionstatus
        //     // });
        // }
        return reports;
    }

    resetForm() {
        this.reportForm.reset();
        this.rowData = [];
        this.originalColumnDefs = [];
        this.columnDefs = [];
        this.gridApi.setRowData([]);
        this.gridApi.setColumnDefs([]);
        this.isFormSubmitted = false;
        this.reportForm.patchValue({
            txtFromDate: this.currentDate,
            txtToDate: this.currentDate
        });
        this.showFiledAnalysisReports = false;
        if(this.userType == 'Customer'){
            this.reportForm.get('ddlCustomer').setValue(this.customerList[0]?.id);
        }
    }

    showInfoNotification(msg: any) {
        this.toastr.info(msg, 'Info');
    }

    showWarningNotification(msg: any) {
        this.toastr.warning(msg, 'Warning');
    }

    openWarningMessageDialog(msg: any) {
        Swal.fire({
            title: 'Warning!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'OK'
        })
    }

    formateDate(date?: any) {
        const inputDate = date != null || undefined ? new Date(date) : new Date();
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
        const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
        const ss = inputDate.getSeconds() < 10 ? ('0' + inputDate.getSeconds()) : inputDate.getSeconds();
        const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
        const dateString = `${year}-${month}-${day}`;
        return { dateString, dateTimeString };
    }

    onCountryChange(origin?) {
        let countryCode: any;
        if (origin) {
            countryCode = this.reportForm.get('ddlOriginCountry').value;
            this.reportForm.controls.ddlOriginState.reset();
            this.reportForm.controls.ddlOriginCity.reset();
            this.originCityList = [];
            this.bindStatesByCountry(countryCode, origin);
            //this.allAWBList = this.allAWBList?.filter(x => (countryCode || x.origincountry === countryCode));
        }
        else {
            countryCode = this.reportForm.get('ddlDestinationCountry').value;
            this.reportForm.controls.ddlDestinationState.reset();
            this.reportForm.controls.ddlDestinationCity.reset();
            this.destinationCityList = [];
            this.bindStatesByCountry(countryCode);
            //this.allAWBList = this.allAWBList?.filter(x => (countryCode || x.destinationcountry === countryCode));
        }
    }

    bindCountries() {
        try {
            this.geoService.GetAllCountries().subscribe((res) => {
                if (res && res.success) {
                    this.countryList = res.data;
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    bindStatesByCountry(countryCode?: string, type?: any) {
        try {
            if (countryCode) {
                this.geoService.GetAllStates({ countrycode: countryCode }).subscribe((res) => {
                    if (res && res.success) {
                        this.countryCode = countryCode;
                        this[type === 'origin' ? 'originStateList' : 'destinationStateList'] = res.data;
                    }
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    onStateChange(origin?) {
        let countryCode: any;
        if (origin) {
            countryCode = this.reportForm.get('ddlOriginState').value;
            this.reportForm.controls.ddlOriginCity.reset();
            this.bindCitiesByState(countryCode, origin);
        }
        else {
            countryCode = this.reportForm.get('ddlDestinationState').value;
            this.reportForm.controls.ddlDestinationCity.reset();
            this.bindCitiesByState(countryCode);
        }
    }

    bindCitiesByState(stateCode?: string, type?: any) {
        try {
            if (stateCode) {
                this.geoService.GetAllCities({ statecode: stateCode }).subscribe((res) => {
                    if (res && res.success) {
                        this[type === 'origin' ? 'originCityList' : 'destinationCityList'] = res.data;
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    }
    bindVendor() {
        this.vendorService.GetAll('').subscribe((res) => {
            this.vendorList = res?.success ? res.data : [];
        })
    }

    bindCustomers(sc) {
        try {
            this.customerService.GetAll({ scid: sc }).subscribe((res) => {
                if (res && res.success) {
                    if (this.userType == 'Customer') {
                        this.customerList = res.data.filter(x => x.id == this.defaultCustomer);
                        this.reportForm.get('ddlCustomer').setValue(this.customerList[0]?.id);
                        this.reportForm.controls['ddlCustomer'].disable();
                    }
                    else {
                        this.customerList = res.data;
                        this.reportForm.controls['ddlCustomer'].enable();
                    }
                }
            });
        } catch (e) {
            console.error(e);
        }
    }
    getServiceCenters() {
        try {
            this.networkService.GetAllServiceCenters().subscribe((res) => {
                if (res && res.success) {
                    this.serviceCenterList = res.data;
                    // bind default service center
                    // this.manifestForm.get('ddlBranch').setValue(this.userServiceCenter.default)
                }
            })
        } catch (error) {

        }
    }

    bindUsers(scid) {
        try {
            this.userManagmentService.GetUserByGroup('fe,se', scid).subscribe((res) => {
                if (res && res.success) {
                    const data = res.data;
                    this.userList = data.filter((item: any) => item.usergroupname === 'Field Executive');
                }
            })
        } catch (err) {
            console.error(err);
        }
    }

    bindProducts() {
        try {
            this.productService.GetAll().subscribe((res) => {
                if (res && res.success) {
                    this.productList = res.data;
                }
            });
        } catch (err) {
            console.error(err);
        }
    }

    bindCompanies() {
        try {
            this.companyService.GetAll({ isactive: true }).subscribe((res) => {
                if (res && res.success) {
                    this.companyList = res.data;
                    // const defaultCompanyObj = this.companyList.filter(x => x.isdefault === true);
                    // this.reportForm.get('ddlCompanies').setValue(defaultCompanyObj);    
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    openColumnSelectorModal() {
        this.updateColumnVisibilityState();
        this.originalColumnDefs = JSON.parse(JSON.stringify(this.columnDefs));
        this.modalRef = this.modalService.open(this.columnSelectorModal, this.ngbModalOptions);
        this.modalRef.result.then(
            (resolve) => {
                if (resolve) {
                    this.saveColumnSelection();
                }
            },
            (reject) => {
                if (reject) {
                    this.revertColumnChanges();
                }
            }
        ); 
    }

    updateColumnVisibilityState() {
        const capitalize = (str) => {
            return str
                .split('_')
                .map((part, index) => {
                    if (index === 0) {
                        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
                    }
                    return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
                })
                .join('_');
        };
    
        if (!this.selectedColumns || this.selectedColumns.length === 0) {
            this.columnDefs = this.allColumns.map(column => ({
                headerName: capitalize(column),
                field: column.toLowerCase(),
                visible: true,
                hide: false,
                width: 150 // Set default width here
            }));
        } else {
            this.columnDefs = this.allColumns.map(column => ({
                headerName: capitalize(column),
                field: column.toLowerCase(),
                visible: this.selectedColumns.includes(column.toLowerCase()),
                hide: !this.selectedColumns.includes(column.toLowerCase()),
                width: this.selectedColumns.includes(column.toLowerCase()) ? 150 : 100 // Set dynamic width
            }));
        }
    
        // Call sizeColumnsToFit() to ensure grid adjusts to fit available width
        this.gridOptions.api.sizeColumnsToFit();
    
        this.updateSelectAllCheckbox();
    }
    


    onColumnVisibilityChanged() {
        this.updateSelectAllCheckbox();
    }

    onChangeSelectAllCheckbox(event: any) {
        const isChecked = event.target.checked;
        this.columnDefs.forEach((colDef: any) => {
            colDef.visible = isChecked;
        });
        this.onColumnVisibilityChanged();
    }

    revertColumnChanges() {
        const originalColumnDefs = JSON.parse(JSON.stringify(this.originalColumnDefs));
        const filteredColumnDefs = originalColumnDefs.filter((col: any) => col.visible);
        this.gridApi.setColumnDefs(filteredColumnDefs);
        this.gridApi.sizeColumnsToFit();

        this.columnDefs.forEach((colDef: ExtendedColDef) => {
            colDef.visible = originalColumnDefs.find(col => col.field === colDef.field)?.visible;
        });
    }

    updateSelectAllCheckbox() {
        this.allColumnsSelected = this.columnDefs.every((colDef: ExtendedColDef) => colDef.visible)
    }

    areColumnSelected(): boolean {
        return this.columnDefs.some((colDefs: ExtendedColDef) => colDefs.visible);
    }

    saveColumnSelection() {
        if (!this.columnDefs) {
            console.error('columnDefs is not initialized');
            return;
        }
    
        if (this.areColumnSelected()) {
            const selectedColumns = this.columnDefs.filter((colDef: ExtendedColDef) => colDef.visible)
                .map((colDef: ExtendedColDef) => colDef.field);
    
            if (this.selectedColumns) {
                this.updateSelectedColumns(selectedColumns);
            } else {
                this.addSelectedColumns(selectedColumns);
            }
    
            const newColumnsDefs = this.columnDefs.map((colDef: ExtendedColDef) => {
                // Define dynamic width based on column
                let columnWidth = 150;  // Default width
                if (colDef.field === 'name') {
                    columnWidth = 200;  // Example: specific width for the "name" column
                } else if (colDef.field === 'description') {
                    columnWidth = 250;  // Example: specific width for the "description" column
                }
    
                return {
                    ...colDef,
                    hide: !colDef.visible,
                    width: columnWidth // Add width to column definition
                };
            });
    
            // Update the column definitions in the grid
            if (this.gridApi) {
                this.gridApi.setColumnDefs(newColumnsDefs);
                this.gridApi.sizeColumnsToFit(); // Adjust columns to fit within the grid
            }
    
            // Close the modal if required
            this.modalRef?.close();
            this.updateColumnVisibilityState();
        } else {
            this.openWarningMessageDialog('No Column Selected, Please Select Column to Save!');
        }
    }
    
    

    addSelectedColumns(selectedColumns: string[]) {
        const report: any = this.reportOptions.filter(x => x.id == this.reportForm.get('ddlReports').value);
        const reportId = report[0].name;
        var obj = {
            id: reportId,
            selectedcolumns: selectedColumns,
            allcolumns: this.allColumns
        };
        try {
            this.ngxLoadService.start();
            // this.reportService.addSelectedColumns(obj).subscribe(res => {
            //     if (res && res.success) {
            //         this.ngxLoadService.stop();
            //         const selectedcolumns = res.data && res.data.length > 0 ? res.data[0].selectedcolumns : null;
            //         this.selectedColumns = selectedcolumns;
            //     } else {
            //         this.ngxLoadService.stop();
            //     }
            // });
        } catch (err) {
            this.ngxLoadService.stop();
            console.log(err);
        }
    }

    updateSelectedColumns(selectedColumns: string[]) {
        const report: any = this.reportOptions.filter(x => x.id == this.reportForm.get('ddlReports').value);
        const reportId = report[0].name;
        var obj = {
            id: reportId,
            selectedcolumns: selectedColumns,
        };
        try {
            this.ngxLoadService.start();
            // this.reportService.updateSelectedColumns(obj).subscribe(res => {
            //     if (res && res.success) {
            //         this.ngxLoadService.stop();
            //         const selectedcolumns = res.data && res.data.length > 0 ? res.data[0].selectedcolumns : null;
            //         this.selectedColumns = selectedcolumns;
            //     } else {
            //         this.ngxLoadService.stop();
            //     }
            // });
        } catch (err) {
            this.ngxLoadService.stop();
            console.log(err);
        }
    }

}